import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import VerCampaignPromotionsDatatable from '../common/ver-campaign-promotions-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';

export class Ver_campaign_promotions extends Component {

    constructor(props) {
        super(props);
        this.deletePromotion = this.deletePromotion.bind(this);
        this.state = {
            results: [],
            campaignData: null,
            id_campaign: null,
        };
    }

    deletePromotion(data_row) {
       Swal.fire({
        title: 'Confirmar',
        text: '¿Desea eliminar la promoción '+ data_row.original.Título + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
     }).then((result) => {
        if(result.value){
            var user = AuthService.getCurrentUser();
            ApiService.deleteCampaignPromotion(user.token,data_row.original.id).then(
                (res) => {
                    toast.success("Promoción eliminada!");
                    this.getDataPromotions();
                },
                error => {
                const resMessage =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                    toast.error(resMessage);
                }
            )
       }
     })
    }

    componentWillMount() {
        let id_campaign = this.props.match.params.id_campaign;
        this.setState({ id_campaign: id_campaign });
        this.getCampaignData(id_campaign);
        this.getDataPromotions();
    }

    getCampaignData(id_campaign){
        var user = AuthService.getCurrentUser();
        ApiService.getWhatsappCampaignDetails(user.token, id_campaign).then(
            (res) => {
                if(res && res.status === 'success')
                {
                    this.setState({ campaignData: res.data });
                }
            },
            error => {
              toast.error("Error al cargar la campaña");
            }
          );
    }

    getDataPromotions(){
        var user = AuthService.getCurrentUser();
        let id_campaign = this.props.match.params.id_campaign;
        ApiService.getCampaignPromotions(user.token, id_campaign).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        let vigencia = 'Sin límite';
                        if(row.valid_from || row.valid_until) {
                            const from = row.valid_from ? new Date(row.valid_from).toLocaleDateString('es-ES') : 'Desde siempre';
                            const until = row.valid_until ? new Date(row.valid_until).toLocaleDateString('es-ES') : 'Sin fin';
                            vigencia = `${from} - ${until}`;
                        }

                        return {
                            id: row.id,
                            Título: row.promotion_title,
                            'Botón CTA': row.call_to_action_text || 'Ver promoción',
                            Vigencia: vigencia,
                            data: row
                        }
                     })
                this.setState({ results:items });
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(){
		return this.state.results.length === 0
			? 'No hay promociones asociadas a esta campaña.'
			: <VerCampaignPromotionsDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={this.state.results.length<=10?this.state.results.length:10}
            pagination={true}
            class="-striped -highlight"
            deletePromotion = {this.deletePromotion}
        />
    }

    render() {
        const { campaignData, id_campaign } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Promociones de Campaña" parent="Promociones" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Promociones de la Campaña{campaignData ? `: ${campaignData.campaign_name}` : ''}</h5>
                        </div>
                        <div className="card-body">
                            {campaignData && (
                                <div className="alert alert-info mb-3">
                                    <strong>Mensaje de la Campaña:</strong> {campaignData.whatsapp_message}
                                    <br />
                                    <strong>Grupo:</strong> {campaignData.Cluster ? campaignData.Cluster.cluster_name : 'Sin grupo'}
                                </div>
                            )}
                            <div className="btn-popup pull-right">
                                <Link to={`/create-campaign-promotion/${id_campaign}`} className="btn btn-secondary">Agregar Promoción</Link>
                            </div>
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_campaign_promotions
